import mixins from 'synergycms_core/src/less/mixins';

export default ({enable901})=> ({
  positionImage: {},
  backgroundImageBase: {},
  column33: {
    '&:first-child': {
      paddingRight: '0',
      '&:lang(ar)': {
        paddignRight: '39px',
        paddingLeft: 0
      },
    },
    '&:last-child': {
      borderBottom: 'none',
      paddingBottom: '0'
    }
  },
  multiHotelOpinion: {},
  roboto13Gray: {},
  hotelContentHeader: {},
  seeMap: {},
  multiHotelShowMapIcon: {
    marginRight: '5px',
    '&:lang(ar)': {
      marginRight: 0,
      marginLeft: '5px'
    },
  },
  listContainer: {},
  buttonImage: {},
  sinceFooter: {},
  infoButton: {},
  hideSlug:{
    display:'none !important'
  },
  footerContainer: {},
  seeRoms: {},
  hotelInfoContainer:{
    '@media (min-width: 901px), print': enable901 ? {
      display:'inline-block',
      verticalAlign:'top',
      width: 'calc(100% - 90px)',
      paddingRight:'100px !important',
      position:'static !important',
      boxSizing:'border-box',
      '&:lang(ar)': {
        paddingRight: '0!important',
        paddingLeft: '100px',
      }
    } : {}
  },
  price: {},
  roomNight: {},
  defaultStyle: {
    background: '#fff',
    //...mixins.boxShadow('0 2px 4px 0 rgba(0,0,0,0.07)'),
    position: 'relative',
    padding: '170px 10px 10px',
    minHeight: '230px',
    boxSizing:'border-box',
    marginBottom: '50px',
    '& $positionImage': {
      height: '160px',
      width: '100%',
      position: 'absolute',
      top: '0',
      left: '0',
      right: '0',
      '& $backgroundImageBase': {
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        height: '160px',
        position: 'absolute',
        top: '0',
        left: '0',
        right: '0'
      },
      '@media (min-width: 901px), print': enable901 ? {
        height: 'auto',
        width: '267px',
        bottom: '0',
        right: 'auto'
      } : {},
      '&:lang(ar)': {
        '@media (min-width: 901px), print': enable901 ? {
          left: 'auto',
          right: 0
        } : {}
      },
    },
    '& $column33': {
      position: 'absolute',
      top: '0',
      right: '0',
      width: 'auto',
      float: 'right',
      '& $multiHotelOpinion': {
        ...mixins.mixinBorderRadius('1.3px'),
        border: data => '1px solid ' + data.secondColor,
        font: data => '16px ' + data.fontFamily1,
        color: data => data.secondColor,
        padding: '4px 4px 4px 28px',
        position: 'relative',
        '& > span': {
          position: 'absolute',
          left: '5px',
          top: '50%',
          lineHeight: '1px',
          '@media (min-width: 901px), print': enable901 ? {
            display: 'block',
            left: '16px',
            fontSize: '18px'
          } : {},
          '&:lang(ar)': {
            left: 'auto',
            right: '5px',
            '@media (min-width: 901px), print': enable901 ? {
              right: '16px',
            } : {}
          }
        },
        '@media (min-width: 901px), print': enable901 ? {
          textAlign: 'right',
          maxWidth: '90px',
          padding: '7px 16px 8px 39px',
          display: 'inline-block',
          '&:lang(ar)': {
            padding: '7px 39px 8px 16px',
          },
        } : {},
      },
      '& $roboto13Gray': {
        display: 'none',
        font: data => '300 13px ' + data.fontFamily1,
        '@media (min-width: 901px), print': enable901 ? {
          display: 'block',
          marginTop: '7px'
        } : {}
      },
      '@media (min-width: 901px), print': enable901 ? {
        top: '17px',
        right:'20px'
      } : {},
      '&:lang(ar)': {
        right: 'auto',
        left: '0',
        float: 'left',
        '@media (min-width: 901px), print': enable901 ? {
          textAlign: 'left',
          left: '20px',
        } : {}
      },
      '& > span': {
        '&:lang(ar)': {
          padding: '4px 28px 4px 4px',
          '@media (min-width: 901px), print': enable901 ? {
            left: 'auto',
            right: 0
          } : {}
        },
      }
    },
    '& $hotelContentHeader': {
      marginTop: '10px',
      '& > span[stars]': {
        paddingTop: '15px',
        fontSize: '13px',
        display: 'block',
        marginBottom: '5px',
        '@media (min-width: 901px), print': enable901 ? {
          paddingTop: '0',
          marginBottom: '0'
        } : {}
      },
      '& $seeMap': {
        marginTop: '11px',
        cursor: 'default',
        '& $multiHotelShowMapIcon': {
          fontSize: '12px',
          verticalAlign: 'bottom',
          marginRight: '3px',
          '@media (min-width: 901px), print': enable901 ? {
            fontSize: '14px'
          } : {},
          '&:lang(ar)': {
            marginRight: 0,
            marginLeft: '3px'
          },
        },
        '@media (min-width: 901px), print': enable901 ? {
          marginTop: '4px',
          paddingBottom: '0px'
        } : {},
      },
      '@media (min-width: 901px), print': enable901 ? {
        marginTop: '0',
        overflow: 'hidden',
        paddingBottom: '10px',
        display:'inline-block',
        verticalAlign:'middle'
      } : {},
    },
    '& $listContainer': {
      padding: '0',
      '& > div': {
        padding: '12px 0 0',
        borderBottom: '1px solid #d8d8d8',
        '@media (min-width: 901px), print': enable901 ? {
          borderBottom: '1px solid #d8d8d8',
          padding: '10px 0 12px'
        } : {}
      },
      '@media (min-width: 901px), print': enable901 ? {
        minHeight: '63px',
        padding: '0'
      } : {}
    },
    '& $rowHotelContent': {
      '@media (min-width: 901px), print': enable901 ? {
        padding: '0 0 7px',
      } : {}
    },
    '& $footerContainer': {
      overflow: 'hidden'
    },
    '& $buttonImage': {
      '@media (min-width: 901px), print': enable901 ? {
        bottom: '5px',
        left: '5px',
        top: 'auto'
      } : {},
      '&:lang(ar)': {
        '@media (min-width: 901px), print': enable901 ? {
          left: 'auto',
          right: '5px'
        } : {}
      },
    },
    '&:hover': {
      '@media (min-width: 901px), print': enable901 ? {
        outlineWidth: '2px',
        ...mixins.boxShadow('0 0 16px 0 #000')
      } : {}
    },
    '@media (min-width: 901px), print': enable901 ? {
      padding: '8px 20px 15px 287px',
      ...mixins.boxShadow('0px 0px 6px -1px #000'),
      '@supports (-webkit-appearance:none)': {
        ...mixins.boxShadow('0 0 4px -2px #000'),
      }
    } : {},
    '&:lang(ar)': {
      direction: 'rtl',
      '@media (min-width: 901px), print': enable901 ? {
        padding: '8px 287px 15px 20px'
      } : {}
    },
  },
  slideStyle: {
    width: '100%',
    border: '1px solid #d8d8d8',
  },
  listContainerSlide: {
    '@media (min-width: 901px)': {
      '& > div': {
        paddingBottom: '12px !important',
        height: '70px',
      },
    }
  },
  rowHotelContent: {
    padding: '12px 0px',
    position: 'relative',
    '&:first-child': {
      paddingTop: 0
    },
    '&:last-child': {
      marginTop: '10px',
      borderBottom: 'none',
      paddingBottom: '0',
      paddingTop: '0',
      textAlign: 'right',
      '&:lang(ar)': {
        textAlign: 'left'
      },
    },
    '& $infoButton': {
      width: '30%',
      maxWidth: '120px',
      display: 'inline-block',
      verticalAlign: 'middle',
      float: 'left',
      '& > a ': {
        height: '40px',
        ...mixins.boxSizing(),
        padding: '12px 0'
      },
      '@media (min-width: 901px), print': enable901 ? {
        maxWidth: '90px'
      } : {},
      '&:lang(ar)': {
        float: 'right'
      },
    },
    '& $seeRoms': {
      float: 'right',
      width: 'calc(70% - 10px)',
      maxWidth: '260px',
      '& > button': {
        height: '40px',
        padding: '0 15px',
        '& > span': {
          font: '400 16px Roboto, sans-serif',
        }
      },
      '@media (min-width: 901px), print': enable901 ? {
        display: 'inline-block',
        maxWidth: '180px'
      } : {},
      '&:lang(ar)': {
        float: 'left'
      },
    }
  },
  multiHotelShowMapText: {
    color: data => data.mainColor,
    font: data => 'normal 13px ' + data.fontFamily1,
    ...mixins.boxSizing(),
    '&:lang(ar)': {
      display: 'inline-block',
      direction: 'ltr',
      marginLeft: '5px',
    }
  },
  buttonTest: {
    display: 'block',
    float: 'right',
    width: '50px',
    border: '1px solid black',
    '&:lang(ar)': {
      float: 'left'
    },
  },
  centerPrice: {
    display: 'table',
    width: '100%',
    marginBottom: '14px',
    font: data => '11px ' + data.fontFamily1,
    color: '#333',
    '& > div': {
      display: 'table-cell',
      verticalAlign: 'middle',
      textAlign: 'left',
      '@media (min-width: 901px), print': enable901 ? {
        padding: '0',
        display: 'inline'
      } : {},
      '&:lang(ar)': {
        textAlign: 'right'
      },
    },
    '& $sinceFooter': {
      paddingLeft: '5px',
      '& > span': {
        color: '#9b9b9b',
        fontSize: '11px'
      },
      '@media (min-width: 901px), print': enable901 ? {
        verticalAlign: 'middle',
        padding: '0',
        marginRight: '3px'
      } : {},
      '&:lang(ar)': {
        paddingLeft: '0',
        paddingRight: '5px',
        '@media (min-width: 901px), print': enable901 ? {
          marginRight: 0,
          marginLeft: '3px'
        } : {}
      }
    },
    '& $price': {
      width: '100%',
      paddingRight: '9px',
      textAlign: 'right',
      '& > span': {
        fontSize: '18px',
        fontWeight: 'bold',
        textAlign: 'right',
        padding: '0',
        '@media (min-width: 901px), print': enable901 ? {
          fontSize: '20px'
        } : {},
        '&:lang(ar)': {
          textAlign: 'left'
        },
      },
      '@media (min-width: 901px), print': enable901 ? {
        padding: '0'
      } : {},
      '&:lang(ar)': {
        textAlign: 'left',
        paddingRight: '0',
        paddingLeft: '9px',
        '@media (min-width: 901px), print': enable901 ? {
          paddingLeft: 0
        } : {}
      },
    },
    '& $roomNight': {
      '& > span': {
        fontSize: '11px',
        '@media (min-width: 901px), print': enable901 ? {
          color: '#333',
          fontWeight: '400'
        } : {}
      },
      '@media (min-width: 901px), print': enable901 ? {
        padding: '0',
        display: 'block',
        textAlign: 'right'
      } : {},
      '&:lang(ar)': {
        '@media (min-width: 901px), print': enable901 ? {
          textAlign: 'left'
        } : {}
      },
    },
    '@media (min-width: 901px), print': enable901 ? {
      display: 'inline-block',
      width: 'auto',
      verticalAlign: 'middle',
      margin: '0 23px 0 0',
      maxWidth: '43%'
    } : {},
    '&:lang(ar)': {
      marginRight: '0',
      marginLeft: '23px'
    }
  },
  discountRibbonContainer: {
    position: 'absolute',
    top: '0',
    zIndex: '1',
    left: '0',
    '@media (min-width: 901px), print': enable901 ? {
      position: 'absolute',
      top: '-2px',
      zIndex: '1',
      left: '1px'
    } : {},
    '&:lang(ar)': {
      left: 'auto',
      right: 0,
      '@media (min-width: 901px), print': enable901 ? {
        right: '1px',
        left: 'auto'
      } : {}
    },
  },
  discountRibbonSpan: {},
  discountRibbon: {
    position: 'absolute',
    top: '10px',
    left: '-5px',
    background: '#4a90e2',
    font: data => '300 20px ' + data.fontFamily1,
    textAlign: 'center',
    color: '#fffdfa',
    height: '25px',
    width: '65px',
    padding: '1px 0',
    boxSizing:'border-box',
    '&:before': {
      content: "''",
      position: 'absolute',
      left: '100%',
      top: '0',
      borderTop: '14px solid transparent',
      borderLeft: '10px solid #4a90e2',
      borderBottom: '11px solid transparent',
      '@media (min-width: 901px), print': enable901 ? {
        borderTop: '31px solid transparent',
        borderLeft: '31px solid #4a90e2',
        borderBottom: '0px solid transparent'
      } : {},
      '&:lang(ar)': {
        right: '100%',
        left: 'auto',
        borderLeft: 'none',
        borderRight: '10px solid #4a90e2',
        '@media (min-width: 901px), print': enable901 ? {
          borderLeft: 'none',
          borderRight: '31px solid #4a90e2'
        } : {}
      },
    },
    '&:after': {
      content: "''",
      position: 'absolute',
      left: '0px',
      bottom: '-5px',
      borderTop: '5px solid #3f628b',
      borderLeft: '5px solid transparent',
      '@media (min-width: 901px), print': enable901 ? {
        left: 'auto',
        right: '100%',
        bottom: '0px',
        borderTop: '31px solid transparent',
        borderRight: '31px solid #4a90e2',
        borderBottom: '0 solid transparent'
      } : {},
    },
    '& $discountRibbonSpan': {
      '&:after': {
        '@media (min-width: 901px), print': enable901 ? {
          content: "''",
          position: 'absolute',
          left: '-31px',
          top: '31px',
          borderLeft: '0px solid transparent',
          borderRight: '12px solid transparent',
          borderTop: '12px solid #476a93'
        } : {},
        '&:lang(ar)': {
          '@media (min-width: 901px), print': enable901 ? {
            left: "auto",
            right: "-31px",
            borderLeft: "12px solid transparent",
            borderRight: "0 solid transparent"
          } : {}
        },
      },
      '&:before': {
        '@media (min-width: 901px), print': enable901 ? {
          content: "''",
          position: 'absolute',
          right: '-31px',
          top: '31px',
          borderLeft: '12px solid transparent',
          borderRight: '0px solid transparent',
          borderTop: '12px solid #476a93'
        } : {},
        '&:lang(ar)': {
          '@media (min-width: 901px), print': enable901 ? {
            left: "-31px",
            right: "auto",
            borderLeft: "0 solid transparent",
            borderRight: "12px solid transparent"
          } : {}
        },
      },
      '& > span': {
        '&:after': {
          '@media (min-width: 901px), print': enable901 ? {
            content: "''",
            position: 'absolute',
            right: '-31px',
            top: '31px',
            borderLeft: '12px solid transparent',
            borderRight: '0px solid transparent',
            borderTop: '12px solid #476a93'
          } : {},
          '&:lang(ar)': {
            '@media (min-width: 901px), print': enable901 ? {
              left: "-31px",
              right: "auto",
              borderLeft: "0 solid transparent",
              borderRight: "12px solid transparent"
            } : {}
          },
        },
        '&:before': {
          '@media (min-width: 901px), print': enable901 ? {
            content: "''",
            position: 'absolute',
            left: '-31px',
            top: '31px',
            borderLeft: '0px solid transparent',
            borderRight: '12px solid transparent',
            borderTop: '12px solid #476a93'
          } : {},
          '&:lang(ar)': {
            '@media (min-width: 901px), print': enable901 ? {
              left: "auto",
              right: "-31px",
              borderLeft: "12px solid transparent",
              borderRight: "0px solid transparent"
            } : {}
          },
        }
      }
    },
    '@media (min-width: 901px), print': enable901 ? {
      top: '18px',
      left: '-10px',
      width: '80px',
      fontSize: '19px',
      padding: '3px',
      transform: 'rotate(-45deg)',
      filter: 'drop-shadow(2px 7px 7px rgba(0, 0, 0, 0.5))',
      height: '31px'
    } : {},
    '&:lang(ar)': {
      left: 'auto',
      right: '-5px',
      '&:before':{
        right: '100%',
        left: 'auto',
        borderLeft: 'none',
        borderRight: '10px solid #4a90e2',
      },
      '&:after':{
        right: '0',
        left: 'auto',
        borderLeft: 'none',
        borderRight: '5px solid transparent',
      },
      '@media (min-width: 901px), print': enable901 ? {
        left: 'auto',
        right: '-10px',
        transform: 'rotate(45deg)',
        '&:before':{
          right: 'auto',
          left: '100%',
          borderLeft: '31px solid #4a90e2',
          borderRight: 'none',
        },
        '&:after':{
          right: '100%',
          left: 'auto',
          borderLeft: 'none',
          borderRight: '31px solid #4a90e2',
        },
      } : {}
    },
  },
  hotelBrand:{
    '& > div:first-child:not(:empty)':{
      width:'66px',
      height:'66px',
      display:'block',
      marginBottom:'7px',
      position:'absolute',
      right:'5px',
      top:'5px',
      '@media (min-width: 901px), print': enable901 ? {
        display:'inline-block',
        verticalAlign:'top',
        marginBottom:'0',
        marginRight:'23px',
        position:'relative',
        '&:lang(ar)': {
          marginRight: '0',
          marginLeft: '23px',
        },
      } : {},
      '&:lang(ar)': {
        right: 'auto',
        left: '5px',
      },
    }
  },
  textLoyalty: {
    marginTop: '8px',
    fontSize: '10px',
    color: '#4a90e2'
  }
});
